import messages from './messages';

const schema = ({ intl }) => ({
  title: intl.formatMessage(messages.blockTitle),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.defaultFieldset),
      fields: ['eyebrow', 'title', 'text'],
    },
    {
      id: 'visibility',
      title: intl.formatMessage(messages.visibilityFieldset),
      fields: ['variant', 'level', 'active', 'start_date', 'end_date'],
    },
  ],
  properties: {
    eyebrow: {
      title: intl.formatMessage(messages.eyebrow),
      type: 'string',
      description: intl.formatMessage(messages.eyebrowDescription),
    },
    title: {
      title: intl.formatMessage(messages.title),
      type: 'string',
      description: intl.formatMessage(messages.titleDescription),
    },
    text: {
      title: intl.formatMessage(messages.text),
      type: 'string',
      widget: 'textarea',
    },
    variant: {
      title: intl.formatMessage(messages.variant),
      type: 'string',
      choices: [
        ['strip', intl.formatMessage(messages.variantStrip)],
        ['banner', intl.formatMessage(messages.variantBanner)],
      ],
      default: 'strip',
    },
    level: {
      title: intl.formatMessage(messages.level),
      type: 'string',
      choices: [
        ['info', intl.formatMessage(messages.levelInfo)],
        ['warning', intl.formatMessage(messages.levelWarning)],
      ],
      default: 'info',
    },
    active: {
      title: intl.formatMessage(messages.active),
      type: 'boolean',
      default: true,
    },
    start_date: {
      title: intl.formatMessage(messages.startDate),
      type: 'string',
      widget: 'date',
      description: intl.formatMessage(messages.startDateDescription),
    },
    end_date: {
      title: intl.formatMessage(messages.endDate),
      type: 'string',
      widget: 'date',
      description: intl.formatMessage(messages.endDateDescription),
    },
  },
  required: ['text'],
});

export default schema;
